export default __webpack_public_path__ + "static/media/facebook.42b15813.png";